import { Box, Skeleton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import investmentFundLang from '../langs/investmentFundLang';

type CGraphMultiCurrencyProps = {
	height: number;
	variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
};

const CGraphMultiCurrency = (props: CGraphMultiCurrencyProps) => {
	const { height, variant } = props;
	const { t } = useTranslation();
	return (
		<Box sx={{ position: 'relative', width: variant === 'rectangular' ? '100%' : height + 'px', margin: 'auto' }}>
			<Skeleton
				animation={false}
				variant={variant ?? 'circular'}
				width="100%"
				height={height}
				sx={{
					backgroundColor: 'rgba(150,150,150,0.1)',

					margin: '10px auto 10px auto',
				}}
			/>
			<Box
				sx={{
					position: 'absolute',
					textAlign: 'center',
					width: '100%',
					padding: '30px',
					top: '50%',
					transform: 'translateY(-50%)',
				}}
			>
				<>{t(investmentFundLang.text_no_graph_when_multiple_currencies.tag)}</>
			</Box>
		</Box>
	);
};

export default CGraphMultiCurrency;
